import { render, staticRenderFns } from "./AyinNamehApp.vue?vue&type=template&id=939f5be4&scoped=true"
import script from "./AyinNamehApp.vue?vue&type=script&lang=js"
export * from "./AyinNamehApp.vue?vue&type=script&lang=js"
import style0 from "./AyinNamehApp.vue?vue&type=style&index=0&id=939f5be4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "939f5be4",
  null
  
)

export default component.exports